import { prepareVisualExportSelection } from './prepareVisualExportSelection';

export const prepareCanvasVisualExportSelection = ({
  canvas = typeof window !== 'undefined' ? window.canvas : undefined,
  activeObject,
} = {}) => {
  const preservedActiveObject =
    activeObject ||
    (typeof canvas?.getActiveObject === 'function'
      ? canvas.getActiveObject()
      : undefined);

  if (typeof canvas?.getObjects === 'function') {
    for (const object of canvas.getObjects()) {
      if (
        object.type === 'MagicFrame' &&
        typeof object.setEditMode === 'function'
      ) {
        object.setEditMode(false);
      }
    }
  }

  const prepared = prepareVisualExportSelection(preservedActiveObject, canvas);

  if (prepared.activeObject && typeof canvas?.setActiveObject === 'function') {
    canvas.setActiveObject(prepared.activeObject);
  }

  return prepared;
};
